import React from "react";

interface SearchInputProps {
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  iconClass?: string;
  searchText?: (value: string) => void;
  loading?: boolean;
}

const Search: React.FC<SearchInputProps> = ({
  placeholder = "Enter...",
  value,
  onChange,
  iconClass = "ti ti-search",
  searchText,
  loading = false,
}) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && searchText && !loading) {
      searchText(value);
    }
  };

  return (
    <div className="d-flex align-items-center gap-2">
      <div className="icon-form mb-0 flex-grow-1">
        <span className="form-icon">
          <i className={iconClass} />
        </span>

        <input
          type="text"
          className="form-control"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={handleKeyDown}
        />
      </div>

      {searchText && (
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => searchText(value)}
          disabled={loading}
        >
          {loading ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              />
              Searching...
            </>
          ) : (
            <>
              <i className="ti ti-search me-1" />
              Search
            </>
          )}
        </button>
      )}
    </div>
  );
};

export default Search;
